var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canShow)?_c('div',{staticClass:"p-3",attrs:{"chat-link-component":""}},[_c('a',{staticClass:"h-100 w-100 d-flex justify-content-center align-items-center",attrs:{"href":_vm.href}},[_c('i',{staticClass:"fal fa-comments"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }